import Section_2 from './Section_2';

export default Section_2;